module.exports = __webpack_public_path__ + "img/中国排球协会@2x.b58957b6.png";